import { useRef } from "react";

import { useStore } from "../../stores/StoreContext";
import { SystemPromptService } from "../LogicServices/SystemPromptService";

export function useSystemPromptService(): SystemPromptService {
  const storeContext = useStore();
  const serviceRef = useRef<SystemPromptService | null>(null);

  if (!serviceRef.current) {
    serviceRef.current = new SystemPromptService(storeContext);
  }

  return serviceRef.current;
}
